import classNames from "classnames"
import * as Icons from "@nova/component-icons"
import { ButtonBorderless } from "@nova/component-btn"
import { useAppSelector } from "integrations/redux/hooks"
import { selectCurrentGeometryToolType } from "plugins/shared/geometry/SharedGeometrySlice"
import { geometryDataStore } from "plugins/shared/layers/GeometryDataStore"

const buttonClasses = ({
    isLight,
    isLeft,
    isDisabled,
}: {
    isLight: boolean
    isLeft: boolean
    isDisabled: boolean
}) => {
    return classNames(
        "w-24 h-9 border-y",
        isLeft ? "rounded-l-lg border-l pr-px" : "rounded-r-lg border-r pl-px",
        {
            "hover:border-r hover:pr-0": !isDisabled && isLeft,
            "hover:border-l hover:pl-0": !isDisabled && !isLeft,
        },
        isLight
            ? classNames(
                  "bg-white-500 text-gray-700 border-black-300",
                  "hover:bg-gray-0 hover:text-gray-900 hover:border-black-400",
                  "active:bg-white-600 active:text-gray-500 active:border-black-400",
                  "disabled:bg-white-600 disabled:text-black-400 disabled:border-black-300"
              )
            : classNames(
                  "bg-black-600 text-white-700 border-white-300",
                  "hover:bg-gray-900 hover:text-gray-0 hover:border-white-400",
                  "active:bg-gray-700 active:text-gray-0 active:border-white-400",
                  "disabled:bg-black-600 disabled:text-white-400 disabled:border-white-300"
              )
    )
}

export const MapFooterUndoRedo = ({ isLight }: { isLight: boolean }) => {
    const { undoStack, redoStack, undo, redo } = geometryDataStore.useGeometryData("undoRedo")
    const currentGeometryType = useAppSelector(selectCurrentGeometryToolType)

    if (!currentGeometryType) return null

    return (
        <div
            className="absolute flex pointer-events-auto rounded-lg -translate-x-1/2 left-1/2"
            style={{ bottom: "calc(100% + 0.5rem)" }}
        >
            <ButtonBorderless
                LeftIcon={Icons.Undo}
                title="Undo"
                disabled={!undoStack.length}
                onClick={undo}
                overrideColors={true}
                isRounded={false}
                className={buttonClasses({ isLeft: true, isLight, isDisabled: !undoStack.length })}
            />
            <ButtonBorderless
                LeftIcon={Icons.Redo}
                title="Redo"
                disabled={!redoStack.length}
                onClick={redo}
                overrideColors={true}
                isRounded={false}
                className={buttonClasses({ isLeft: false, isLight, isDisabled: !redoStack.length })}
            />
        </div>
    )
}
